/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import PropTypes from "prop-types";
import cn from "classnames";
import { useMediaQuery } from "react-responsive";
import { Navigation, EffectFade, Keyboard, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import useSwiperRef from "helpers/hooks/useSwiperRef";
import ModalFull from "components/shared/stays/ModalFull";
import IconPrevious from "solar/icons/IconPrevious";
import IconNext from "solar/icons/IconNext";
import SlideshowMedia from "components/shared/stays/SlideshowMedia";
import styles from "components/shared/stays/Slideshow.module.scss";

export default function Slideshow({
  show,
  handleClose,
  initialSlide = 0,
  slides,
}) {
  const breakpoint = 768; // rt: should probably pull from a token

  const greaterThanBreakpoint = useMediaQuery({
    query: `(min-width: ${breakpoint}px)`,
  });

  const [paginationEl, paginationElRef] = useSwiperRef();
  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();

  const onlyOneSlide = slides?.length === 1;

  const pagination = (
    <div
      className={cn(styles.pagination, onlyOneSlide && styles.disable)}
      ref={paginationElRef}
    />
  );

  return (
    <ModalFull
      show={show}
      handleClose={handleClose}
      pagination={pagination}
      light={false}
    >
      <div className={styles.component}>
        <div className={styles.grid}>
          <div
            className={cn(styles.navigation, onlyOneSlide && styles.disable)}
            ref={prevElRef}
          >
            <div className={styles.button}>
              <IconPrevious />
            </div>
          </div>
          <div
            className={cn(
              styles.navigation,
              styles.next,
              onlyOneSlide && styles.disable
            )}
          >
            <div className={styles.button} ref={nextElRef}>
              <IconNext />
            </div>
          </div>
          <div className={styles.slides}>
            <Swiper
              modules={[Navigation, EffectFade, Keyboard, Pagination]}
              initialSlide={initialSlide - 1}
              speed={200}
              loop={greaterThanBreakpoint}
              effect={greaterThanBreakpoint && "fade"}
              cssMode={!greaterThanBreakpoint}
              fadeEffect={
                greaterThanBreakpoint && {
                  crossFade: true,
                }
              }
              keyboard={{
                enabled: true,
              }}
              pagination={{
                el: paginationEl,
                type: "fraction",
              }}
              navigation={{
                prevEl,
                nextEl,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.pagination.el = paginationElRef.current;
                swiper.params.navigation.prevEl = prevElRef.current;
                swiper.params.navigation.nextEl = nextElRef.current;
                swiper.navigation.update();
              }}
            >
              {slides?.map((item) => (
                <SwiperSlide key={item.id} className={styles.slide}>
                  <SlideshowMedia slide={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </ModalFull>
  );
}

Slideshow.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialSlide: PropTypes.number,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      position: PropTypes.number,
      created_at: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
      }),
    })
  ).isRequired,
};
